module.exports = {
      id: "login-usage",
      viewBox: "0 0 14.742 20.333",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#login",
      toString: function () {
        return this.url;
      }
    }